package com.bikompanion.ui.home

/** The map on its own: the bottom of the back stack, which is never popped. */
data object MapRoute : HomeRoute
